import * as Sentry from '@sentry/vue';
import { Platform } from 'quasar';
import { boot } from 'quasar/wrappers';
import {
  AFInit,
  AppsFlyer,
} from 'src/../src-capacitor/node_modules/appsflyer-capacitor-plugin';

let appsFlyer: typeof AppsFlyer;

export default boot(({}) => {
  if (!Platform.is.capacitor) return;

  const IOSAppID = '1573857405';
  const afConfig: AFInit = {
    appID: IOSAppID,
    devKey: process.env.APPS_FLYER_DEV_KEY as string,
    isDebug: true,
    waitForATTUserAuthorization: 10,
    minTimeBetweenSessions: 6,
    registerOnDeepLink: true,
    registerConversionListener: true,
    registerOnAppOpenAttribution: false,
    deepLinkTimeout: 4000,
    useReceiptValidationSandbox: true,
    useUninstallSandbox: true,
  };

  try {
    void AppsFlyer.initSDK(afConfig);
    appsFlyer = AppsFlyer;
  } catch (e) {
    Sentry.captureException(e);
  }
});

export const useAppsFlyer = () => ({ appsFlyer });
